import { NgModule } from '@angular/core';
import { MeatBallMenuDirective } from './meatball-menu.directive';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MeatBallMenuComponent} from "./meatball-menu.component";

@NgModule({
  declarations: [
    MeatBallMenuComponent,
    MeatBallMenuDirective,
  ],
    imports: [
        CommonModule,
        MatTooltipModule,
    ],
  exports: [
    MeatBallMenuComponent,
    MeatBallMenuDirective,
  ],
})
export class MeatBallMenuModule {}
